module.exports = __webpack_public_path__ + "img/8.edb6a95a.png";